'use client'

import { memo } from 'react'
import { Moon, Sun } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useNinxl8BitTheme } from './use-8bit-theme'

/** Pixel-styled light/dark toggle for landing visitors */
export const Ninxl8BitThemeToggle = memo(function Ninxl8BitThemeToggle({
  className,
}: {
  className?: string
}) {
  const { theme, toggleTheme } = useNinxl8BitTheme()
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(
        'ninxl-8bit-theme-toggle inline-flex items-center gap-2 border-[3px] border-[color:var(--ninxl-8bit-border)] bg-[color:var(--ninxl-theme-btn-bg)] px-3 py-2 text-[color:var(--ninxl-theme-fg)] shadow-[3px_3px_0_0_var(--ninxl-8bit-dim)] transition hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[2px_2px_0_0_var(--ninxl-8bit-dim)]',
        className,
      )}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={isDark}
    >
      {isDark ? (
        <Sun className="h-4 w-4" aria-hidden />
      ) : (
        <Moon className="h-4 w-4" aria-hidden />
      )}
      <span className="ninxl-8bit-label hidden text-[10px] sm:inline">
        {isDark ? 'Light' : 'Dark'}
      </span>
    </button>
  )
})
